import styled from "styled-components";

import { IconProps } from "./Icon";

export const Layout = styled.svg<IconProps>`
  box-sizing: border-box;
  ${({ fill }) => fill && `fill: ${fill};`}
`;
